jQuery(document).ready(function($) {
	// Run on initial load
	handleResize();

	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

	// Handle clear button clicks for Basic Search filters
	// Works with both <i> and <button> elements
	$(document).on('click', '.filter-clear-btn', function(e) {
		e.preventDefault();
		e.stopPropagation();

		const filterName = $(this).data('filter');
		const $clearBtn = $(this);

		// Handle date inputs - check for both filter ID patterns
		if (filterName === 'start_date' || filterName === 'end_date') {
			// Clear via Flatpickr API to trigger onChange and reset linked date constraints
			var inputIds = [filterName, 'aggregator_' + filterName];
			inputIds.forEach(function(id) {
				var el = document.getElementById(id);
				if (el && el._flatpickr) {
					el._flatpickr.clear();
				} else if (el) {
					el.value = '';
				}
			});
			$clearBtn.remove();
			// Remove bold from label
			$(`label[for="${filterName}"], label[for="aggregator_${filterName}"]`).removeClass('filter-label-active');
			// Announce to screen reader
			announceToScreenReader(filterName.replace('_', ' ') + ' filter cleared');
		}
		// Handle in_game_network checkbox
		else if (filterName === 'in_game_network') {
			$('#in-game-network').prop('checked', false);
			$('label[for="in-game-network"]').removeClass('filter-label-active');
			$clearBtn.remove();
			// Announce to screen reader
			announceToScreenReader('In The Game Network filter cleared');
		}
		// Handle checkbox dropdowns (counties, regions)
		else {
			const $col = $clearBtn.closest('.col-12, .col-md-6');
			const $dropdown = $col.find('.dropdown[data-filter-group="' + filterName + '"]');
			$dropdown.find('input[type="checkbox"]').prop('checked', false);
			// Update options count badge
			$dropdown.find('.options-count').remove();
			// Remove clear button and bold from label
			$col.find('.form-label').removeClass('filter-label-active');
			$clearBtn.remove();
			// Announce to screen reader
			announceToScreenReader(filterName + ' filter cleared');
		}
	});
});

// Accessibility: Announce message to screen readers
function announceToScreenReader(message) {
	var announcement = document.createElement('div');
	announcement.setAttribute('role', 'status');
	announcement.setAttribute('aria-live', 'polite');
	announcement.className = 'visually-hidden';
	announcement.textContent = message;
	document.body.appendChild(announcement);
	setTimeout(function() {
		announcement.remove();
	}, 1000);
}

// DropDown Hover/Click - Accessibility-aware version
function bdDropdownHover() {
	// Show dropdown on hover, but preserve keyboard functionality
	jQuery('.navbar .dropdown').on('mouseenter', function() {
		if (jQuery('.navbar-toggler').is(':hidden') && !jQuery(this).is(':focus-within')) {
			jQuery(this).addClass('show');
			jQuery(this).find('.dropdown-toggle').attr('aria-expanded', 'true');
			jQuery(this).find('.dropdown-menu').addClass('show');
		}
	}).on('mouseleave', function() {
		if (jQuery('.navbar-toggler').is(':hidden') && !jQuery(this).is(':focus-within')) {
			jQuery(this).removeClass('show');
			jQuery(this).find('.dropdown-toggle').attr('aria-expanded', 'false');
			jQuery(this).find('.dropdown-menu').removeClass('show');
		}
	});

	// Handle keyboard focus - keep open when focused
	jQuery('.navbar .dropdown').on('focusin', function() {
		jQuery(this).addClass('show');
		jQuery(this).find('.dropdown-toggle').attr('aria-expanded', 'true');
		jQuery(this).find('.dropdown-menu').addClass('show');
	}).on('focusout', function(e) {
		// Only close if focus is leaving the dropdown entirely
		var $dropdown = jQuery(this);
		setTimeout(function() {
			if (!$dropdown.is(':focus-within')) {
				$dropdown.removeClass('show');
				$dropdown.find('.dropdown-toggle').attr('aria-expanded', 'false');
				$dropdown.find('.dropdown-menu').removeClass('show');
			}
		}, 100);
	});

	// Go to the parent link on click
	jQuery('.dropdown > a').click(function(){
		location.href = this.href;
	});

}
function handleResize() {
	var vp_width = window.innerWidth;
	if ( vp_width >= 992) {
		bdDropdownHover();
	}
}
// Run on initial load
handleResize();
// Run on resize
jQuery(window).resize(handleResize);


// Loaded
console.log('mc-theme.js loaded');